<template>
	<CommonLink
		ref="button"
		:class="[$style.commonLink, stretch && $style.stretch]"
		:link="link"
		:data-test="buttonContentProps.dataTest"
		:tracking-label="link.text"
		:analytics-context="analyticsContext"
	>
		<CommonButtonVisual
			v-bind="buttonContentProps"
			:class="buttonClass"
		/>
	</CommonLink>
</template>

<script lang="ts" setup>
import type { ButtonContentProps } from '../common-button/common-button-visual.vue';
import type { CommonButtonLinkProps } from './common-button-link-types';

const props = withDefaults(defineProps<CommonButtonLinkProps>(), {
	buttonType: 'primary',
	stretch: false,
	buttonClass: undefined,
	contentClassName: undefined,
	iconStart: undefined,
	iconEnd: undefined,
	analyticsContext: undefined,
	dataTest: undefined,
});

const button = useTemplateRef('button');

const buttonContentProps = computed<ButtonContentProps>(() => {
	const dataTest = props.dataTest ? props.dataTest : `button-link-${props.buttonType}`;
	const {
		link: { text: label },
		...buttonContentProps
	} = props;

	return { ...buttonContentProps, label, dataTest };
});

defineExpose({
	refs: {
		button,
	},
});
</script>

<style lang="scss" module>
.stretch {
	width: 100%;
}

.commonLink {
	text-decoration: none;
	display: inline-flex;
}
</style>
